import { render, staticRenderFns } from "./ClientEditTab.vue?vue&type=template&id=6f17f5f6&"
import script from "./ClientEditTab.vue?vue&type=script&lang=js&"
export * from "./ClientEditTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports